import React from 'react'

function SvgGraduateHatOrangeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      viewBox="0 0 21 20"
    >
      <path
        stroke="#FF692E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M4.833 8.333v5.01c0 .299 0 .448.046.58.04.117.106.223.192.312.098.1.232.166.5.3l4.5 2.25c.218.11.327.164.442.186a.835.835 0 00.307 0c.115-.022.224-.076.443-.186l4.5-2.25c.268-.134.401-.2.499-.3a.833.833 0 00.192-.312c.046-.132.046-.281.046-.58v-5.01M2.333 7.083l8.035-4.017a.907.907 0 01.222-.093c.05-.01.103-.01.153 0 .058.01.112.038.222.093L19 7.083l-8.035 4.018a.907.907 0 01-.222.093.418.418 0 01-.153 0 .907.907 0 01-.222-.093L2.333 7.083z"
      ></path>
    </svg>
  )
}

export default SvgGraduateHatOrangeIcon
